import {
  // getTableViewByType,
  // ATTR2PROP,
  // widgetFromProp,
  // dateFiler,
  // makeIcon,
  // makeFilterAttrs,
  getBottomComponentHtml,
} from './table-view';

import {
  decoderElement,
  decoders,
} from './decode-fact';

require('./fact-bottom.component.scss');

export function FactBottomComponent($compile) {
  return {
    restrict: 'AE',
    scope: {
      filter: '=',
      fact: '=',
      openImage: '=',
    },
    controller: function($scope, $element, $sce, LocalStorageService, FaceService) {
      $scope.trustAsHtml = $sce.trustAsHtml;
      const setHeight = function() {
        $element.height($element.parent().height() - 10);
      };

      $scope.$on('dashboardResize', setHeight);
      $scope.$on('resize', setHeight);
      $scope.$on('splitter3Changed', (e, d, d2, name) => {
        setHeight();
      });

      const getTextElement = e => {
        const widgetElement = e.target.closest('.widget-value');
        const textElement = widgetElement.querySelector('.fact-text');
        return textElement ? textElement : widgetElement;
      };

      $scope.decodeText = (e, type) => {
        const textElement = getTextElement(e);
        if (!textElement.innerTextOriginal) textElement.innerTextOriginal = textElement.innerText;
        const decoders1 = decoders;
        const decoded = decoders[type](textElement.innerTextOriginal);
        textElement.innerText = decoded;
        // console.log(decoded);

      };

      $scope.copyToClippboard = (e) => {
        const textElement = getTextElement(e);
        // const text = e.target.closest('.widget-value').innerText;
        LocalStorageService.copyTextToClipboard(textElement.innerText);
      };

      $scope.openFace = (fact, index) => {
          FaceService.openFace(fact, index);
      };

    },
    link: function(scope, element, attrs) {
      scope.$watch('fact', function(newVal, oldVal) {
        if (!scope.filter) return;
        const fact = newVal ? newVal : {};
        const widget2 = getBottomComponentHtml(fact);
        element.html(widget2);
        $compile(element.contents())(scope);
      });
    },
  };
}



// WEBPACK FOOTER //
// ./src/facts/fact-bottom.component.js